
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fill: Boolean,
    size: String,
    color: String
  },
  name: 'AppLoader',
  setup() {
    return {}
  }
})
